module.exports = __webpack_public_path__ + "images/gifted-a455a68479ac1ae38f0d08046031cd9f.png";